/* Free-delivery progress bar: keeps every [data-ww-freeship] block in sync with the cart. */
(function () {
  if (window.wwFreeshipInit) return;
  window.wwFreeshipInit = true;

  function money(cents, currency) {
    try {
      var s = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
      var prefix = { SGD: 'S', USD: 'US', CAD: 'CA', AUD: 'A', NZD: 'NZ' }[currency];
      return prefix && s.indexOf('$') === 0 ? prefix + s : s;
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  async function update() {
    var blocks = document.querySelectorAll('[data-ww-freeship]');
    if (!blocks.length) return;
    var cart;
    try {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    } catch (e) {
      return;
    }
    blocks.forEach(function (el) {
      // data-goal is already in the shopper's currency (cents), set per currency in Liquid.
      var goal = parseInt(el.dataset.goal, 10) || 20000;
      var left = goal - cart.total_price;
      var pct = Math.max(0, Math.min(100, Math.round((cart.total_price / goal) * 100)));
      el.hidden = cart.item_count === 0;
      el.classList.toggle('is-done', left <= 0);
      el.querySelector('.ww-freeship__text').innerHTML =
        left > 0
          ? "You're <strong>" + money(left, cart.currency) + '</strong> away from free delivery'
          : "You've unlocked <strong>free delivery</strong>";
      el.querySelector('.ww-freeship__fill').style.width = pct + '%';
    });
  }

  update();
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(update, 60); });
  }
  // The add-to-cart pop-up re-renders its contents; refresh whenever it opens.
  new MutationObserver(function (records) {
    if (records.some(function (r) { return r.target.classList && r.target.classList.contains('active'); })) update();
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });
})();
